module.exports = __webpack_public_path__ + "static/media/20170501-DSC07963-3_Small.d822703a.jpg";